import React, { FunctionComponent } from "react";

import { LanguagesDataProvider } from "../../../../common/data/lookup-data-providers/LanguagesDataProvider";
import { OriginatorsDataProvider } from "../../../../common/data/lookup-data-providers/OriginatorsDataProvider";
import { CreateFileRecordForm } from "./CreateFileRecordForm";
import { CreateFileRecordStateProvider } from "./hooks/state/CreateFileRecordStateProvider";

export const CreateFileRecordDashboard: FunctionComponent = () => {
    return (
        <OriginatorsDataProvider>
            <LanguagesDataProvider>
                <CreateFileRecordStateProvider>
                    <CreateFileRecordForm />
                </CreateFileRecordStateProvider>
            </LanguagesDataProvider>
        </OriginatorsDataProvider>
    );
};
